import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {LinkSchema} from './link'
import {AssetSchema} from './asset'

export const PrimerComponentHeroSchema = buildEntrySchemaFor('primerComponentHero', {
  fields: z.object({
    align: z.literal('start').or(z.literal('center')),
    label: z.string().optional(),
    heading: z.string(),
    image: AssetSchema.optional(),
    imagePosition: z.literal('Block').or(z.literal('Inline')).optional(),
    description: z.string(),
    callToActionPrimary: LinkSchema.optional(),
    callToActionSecondary: LinkSchema.optional(),
  }),
})

export type PrimerComponentHero = z.infer<typeof PrimerComponentHeroSchema>
